import React from 'react';
import { formatMoney } from '../../util/currency';
import css from './PriceBadge.module.css';

const PriceBadge = props => {
  const { price, intl } = props;

  if (!price) {
    return null;
  }

  const formattedPrice = formatMoney(intl, price);

  return (
    <div className={css.root}>
      <span className={css.priceText}>{formattedPrice}</span>
    </div>
  );
};

export default PriceBadge;
